<template>
  <div v-if="pagination.current_page !== pagination.pages && !!pagination.pages"
       class="ml-12 text-sm text-icon-hover cursor-pointer hover:text-red
              border-b border-icon-hover border-opacity-25 border-dashed">
    {{ $t('showMore') }}
  </div>
</template>

<script>
export default {
  name: "PaginationShowMore",
  props: {
    pagination: {
      type: Object,
      required: true
    }
  },
  i18n: {
    messages: {
      en: {
        showMore: 'Show more'
      },
      ru: {
        showMore: 'Показать больше'
      }
    }
  }
}
</script>